import React from "react";

import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Chip } from 'primereact/chip';

export default function Experience({data}) {

    const customMarker = (item) => (
        <img src={require(`../../static/assets/logos/${item.logo}`)} alt="logo" 
            className="border-circle shadow-2 p-2" onError={(e) => e.target.src = "/logos/default.png"} 
            style={{width: "3rem", height: "3rem", border: "2px solid #FB7185", margin: '1rem 0rem'}} 
        />
    );

    const formatDate = (value) => {
        if (!value) {
            return null;
        }

        let date;
        if (typeof value === 'string') {
            const monthMatch = value.match(/^(\d{4})-(\d{2})$/);

            if (monthMatch) {
                const [, year, month] = monthMatch;
                date = new Date(Number(year), Number(month) - 1, 1);
            }
        }

        if (!date) {
            date = new Date(value);
        }

        if (Number.isNaN(date.getTime())) {
            return value;
        }

        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    };

    const buildTimelineLabel = (item) => {
        const start = formatDate(item.start_date) ?? "—";
        const end = formatDate(item.end_date) ?? "Present";

        return `${start} - ${end}`;
    };

    const eventTemplate = (item) => (
        <Card className="card-content">
            <h3 className="mt-0 mb-2"><b>{item.title}</b></h3>
            <p className="my-1 gray"><i className="pi pi-building"></i> &nbsp;{item.company}</p>
            <p className="my-1 gray"><i className="pi pi-map-marker"></i> &nbsp;{item.location}</p>
            <p className="gray">
                {item.description}
            </p>
            <div className="obtained-skills card flex flex-wrap gap-2">
                {item.skills.map((skills, index) => (
                    <Chip key={index} label={skills} />
                ))}
            </div>
        </Card>
    );

    return (
        <div id="experience" className="card">
            <h2 className="title">Professional Saga</h2>
            <Timeline value={data} opposite={buildTimelineLabel} marker={customMarker} content={eventTemplate} />
        </div>
    );
}
